<div class="page">
    <div class="header">
        <h2>{{ 'admin.tool-history.lifecycle-history-table.title' | translate }}</h2>
        <app-report-download-form [tableConfig]="tableConfig"
                                  [isLoading]="isLoadingDownload"
                                  [appendTo]="'body'"
                                  (filterChange)="onFilterChange(tableFilters, $event)"
                                  (reportDownload)="onLifecycleHistoryDownload($event)">
        </app-report-download-form>
    </div>
    <div class="content">
        <app-lifecycle-history-table [toolLifecycleHistory]="toolLifecycleHistory"
                                     [isLoading]="isLoadingToolLifecycleHistory"
                                     [tableConfig]="tableConfig"
                                     [hasTitle]="false"
                                     [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                     (sortChange)="onSortChange($event)"
                                     (pageChange)="onPageChange($event)"
                                     (selectTicket)="onSelectTicket($event)"
                                     (filterChange)="onFilterChange($event.filters, reportFilters)">
        </app-lifecycle-history-table>
        <app-ticket-details-modal (closeTicket)="onCancelTicket($event)"
                                  (downloadFile)="onDownloadFile($event)">
        </app-ticket-details-modal>
        <app-confirmation-modal (scanEvent)="confirmCancelTicket($event)"
                                title="{{'atom.tickets.closeTicketPopup.popupTitle' | translate}}"
                                question="{{'atom.tickets.closeTicketPopup.popupQuestion' | translate}}"
                                message="{{'atom.tickets.closeTicketPopup.popupMessage' | translate}}"
                                [displayReasonMode]="false">
        </app-confirmation-modal>
    </div>
</div>
